// Règles d'heures du Calcul salaire (source unique, réutilisée par l'historique des salariés désactivés).
export const calculateAmazonHours = (tourType) => {
  if (!tourType) return 0;
  const type = tourType.toUpperCase().trim();
  if ((type.includes('SDA') && type.includes('B') && type.includes('C')) ||
      (type.includes('SAME') && type.includes('A') && type.includes('B') && type.includes('C'))) return 10;
  if ((type.includes('SDA') && type.includes('B')) ||
      (type.includes('SAME') && type.includes('A') && type.includes('B'))) return 7;
  if ((type.includes('SDA') && type.includes('C')) ||
      (type.includes('SAME') && type.includes('A') && type.includes('C'))) return 7;
  if ((type.includes('SDB') && type.includes('C')) ||
      (type.includes('SAME') && type.includes('B') && type.includes('C'))) return 7;
  if (type === 'NEXT' || type.includes('NEXT')) return 7;
  if (type === 'SDA' || type === 'SAME A' || type === 'SAMEA') return 4;
  if (type === 'SDB' || type === 'SAME B' || type === 'SAMEB') return 3;
  if (type === 'SDC' || type === 'SAME C' || type === 'SAMEC') return 3;
  if (type.includes('SAME') || type.startsWith('SD')) return 4;
  return 0;
};

export const COLIS_PRIVE_MISSION_HOURS = 7.75; // 7h45
export const calculateColisPriveHours = () => COLIS_PRIVE_MISSION_HOURS;

export const isColisPriveSchedule = (schedule) => {
  const siteName = (schedule.site_name || '').toLowerCase();
  const tourType = (schedule.tour_type || '').toLowerCase();
  const comment = (schedule.comment || '').toLowerCase();
  return siteName.includes('colis') || siteName.includes('privé') || siteName.includes('prive') ||
    tourType.includes('colis') || tourType.includes('privé') ||
    comment.includes('livrés:') || comment.includes('retours:');
};

export const isMissionApproved = (schedule) => {
  const status = String(schedule?.status || '').trim().toLowerCase();
  const v = String(schedule?.validation_status || '').trim().toLowerCase();
  return status === 'present' && (v === 'approved' || v === 'validated');
};

// Heures comptées comme dans le Calcul salaire : 0 tant que la mission n'est pas validée.
export const countedHours = (schedule) => {
  if (!isMissionApproved(schedule)) return 0;
  if (schedule.manual_hours !== undefined && schedule.manual_hours !== null) return Number(schedule.manual_hours) || 0;
  return isColisPriveSchedule(schedule) ? COLIS_PRIVE_MISSION_HOURS : calculateAmazonHours(schedule.tour_type);
};
